import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import SectionHead from "@/components/SectionHead";
import { Reveal, EASE } from "@/components/Reveal";
import { FAQS } from "@/lib/data";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="faq-section" className="relative bg-[#060B18] py-24">
      <div className="mx-auto max-w-3xl px-6">
        <SectionHead center overline="FAQ" title="Questions, Answered." testid="faq-heading" />
        <div className="space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <Reveal key={f.q} delay={i * 0.04}>
                <div
                  data-testid={`faq-item-${i + 1}`}
                  className={`overflow-hidden rounded-2xl border transition-colors duration-300 ${
                    isOpen ? "border-sky-400/30 bg-[#0A0F1D]" : "border-white/[0.08] bg-[#0A0F1D]/50"
                  }`}
                >
                  <button
                    data-testid={`faq-question-${i + 1}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                    aria-expanded={isOpen}
                  >
                    <span className={`text-[15px] font-medium transition-colors duration-300 ${isOpen ? "text-white" : "text-slate-300"}`}>
                      {f.q}
                    </span>
                    <motion.span animate={{ rotate: isOpen ? 45 : 0 }} transition={{ duration: 0.3, ease: EASE }} className="shrink-0 text-sky-400">
                      <Plus size={18} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: EASE }}
                      >
                        <p data-testid={`faq-answer-${i + 1}`} className="px-6 pb-6 text-sm leading-relaxed text-slate-400">
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
